import { render, staticRenderFns } from "./FlatRate.vue?vue&type=template&id=7e419b36&scoped=true&"
import script from "./FlatRate.vue?vue&type=script&lang=js&"
export * from "./FlatRate.vue?vue&type=script&lang=js&"
import style0 from "./FlatRate.vue?vue&type=style&index=0&id=7e419b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e419b36",
  null
  
)

export default component.exports